import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="field"
export default class extends Controller {
  static get targets() {
    return ["input"]
  }

  connect() {
  }

  blur() {
    // Checks if the field has content, if so, adds the class 'used' to the field which keeps the label up and out of the way.
    if (this.inputTarget.value.length != 0) {
      this.inputTarget.classList.add('used')
    } else {
      this.inputTarget.classList.remove('used')
    }
  }
}